"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorderFrame = void 0;
const react_1 = __importDefault(require("react"));
const BorderFrame = ({ children }) => {
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement("div", { className: "text-xs uppercase tracking-wider text-slate-3" }, "Window Border"),
        react_1.default.createElement("div", { className: "border border-slate-3" }, children)));
};
exports.BorderFrame = BorderFrame;
